import { conversationsApi } from "../store/api/conversationsApi";
import { runMutation, runQuery, runQueryNoArg } from "../store/api/runtime";

type JsonObject = Record<string, unknown>;
interface ApiPayload extends JsonObject {
  message?: string;
}

export interface ConversationMessageDto {
  id: string;
  senderId: string;
  body: string;
  attachmentUrl?: string | null;
  createdAt: string;
  flaggedForReview?: boolean;
  clientMessageId?: string;
  status?: "pending" | "failed" | "sent";
  error?: string;
}

export interface SendMessageResponse {
  conversationId: string;
  message: ConversationMessageDto;
  lastMessage: string;
  updatedAt: string;
}

export interface UnreadThreadsCountResponse {
  count: number;
}

export async function fetchConversations(): Promise<unknown> {
  return runQueryNoArg(conversationsApi.endpoints.fetchConversations.initiate);
}

export async function fetchConversationsWithSignal(_signal?: AbortSignal): Promise<unknown> {
  return fetchConversations();
}

export async function fetchConversationById(id: string, _signal?: AbortSignal): Promise<unknown> {
  return runQuery(conversationsApi.endpoints.fetchConversationById.initiate, id);
}

export async function fetchUnreadThreadsCount(): Promise<UnreadThreadsCountResponse> {
  return runQueryNoArg(conversationsApi.endpoints.getUnreadThreadsCount.initiate);
}

export async function startConversation(listingId: string, message: string): Promise<ApiPayload> {
  return runMutation(conversationsApi.endpoints.startConversation.initiate, { listingId, message });
}

export async function sendMessage(
  conversationId: string,
  message: string,
  clientMessageId?: string,
  attachment?: string,
): Promise<ApiPayload | SendMessageResponse> {
  return runMutation(conversationsApi.endpoints.sendMessage.initiate, { conversationId, message, clientMessageId, attachment });
}

export async function markConversationRead(conversationId: string): Promise<unknown> {
  return runMutation(conversationsApi.endpoints.markConversationRead.initiate, { conversationId });
}

export async function deleteConversation(conversationId: string): Promise<ApiPayload> {
  return runMutation(conversationsApi.endpoints.deleteConversation.initiate, conversationId);
}

export async function deleteMessage(conversationId: string, messageId: string): Promise<ApiPayload> {
  return runMutation(conversationsApi.endpoints.deleteMessage.initiate, { conversationId, messageId });
}
